import { baseApi } from "../baseApi";

export const districtApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({

    // CREATE District
    createDistrict: builder.mutation({

      query: (data) => ({
        url: "/district-create",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["District"],
    }),

    // GET District
    getDistrict: builder.query({
      query: ({ page = 1,limit = 10,search = "",status = "",}={}) => 
        `/district-list?page=${page}&limit=${limit}&search=${search}&status=${status}`,
      providesTags: ["District"],
    }),

    // UPDATE District
    updateDistrict: builder.mutation({
      query: (data) => ({
        url: `/district-update`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["District"],
    }),

    changeStatausDistrict: builder.mutation({
      query: (id) => ({
        url: `/district-status/${id}`,
        method: "GET",
        }),
      invalidatesTags: ["District"],
    }),

 deleteDistrict: builder.mutation({
  query: (data) => ({
    url: `/district-delete`,
    method: "DELETE",
    body:data
  }),

  invalidatesTags: ["District"],
})

  })

});

export const {

  useCreateDistrictMutation,
  useGetDistrictQuery,
  useUpdateDistrictMutation,
  useDeleteDistrictMutation,

} = districtApi;